// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"600":"36f28db0","913":"fa8ee874"}[chunkId] + ".chunk.css";
};